/**
 * "You don't have access to this page" — the one answer for a page the signed-in
 * user cannot open (Deep-test ADM-006).
 *
 * Shown by RouteGate in place of the page, so the page never mounts and never
 * fires the requests that would be refused. That matters more than it looks:
 * the alternative was a full admin screen whose every call 403'd, after which
 * its empty states said "No users found" about an organisation full of users.
 *
 * It says what is true and what to do — ask an administrator — and offers the
 * way back. It does not name the permission string: that is vocabulary for the
 * administrator's role editor, not for the person who was turned away.
 */
import { Link } from 'react-router-dom';
import { LockClosedIcon } from '@heroicons/react/24/outline';

export default function NoAccess() {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-20 text-center" data-testid="no-access">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-surface-muted">
        <LockClosedIcon className="h-7 w-7 text-content-subtle" aria-hidden="true" />
      </div>
      <h1 className="text-lg font-semibold text-content">You don&apos;t have access to this page</h1>
      <p className="mt-2 max-w-md text-sm text-content-muted">
        Your role in this organisation does not include it. If you need it for your work, ask an
        administrator in your organisation to give your account access.
      </p>
      <Link to="/dashboard" className="btn-primary mt-6">Go to your dashboard</Link>
    </div>
  );
}
